<template>
    <div>
        <vue-element-loading :active="isLoading" is-full-screen text="Please wait..." />
        <lineChart
            :chart-data="lineChartData"
            class="chart-height"
        ></lineChart>
       <table class="table" style="text-align:center;margin-top:20px;">
            <tr>
                <td colspan="6" class="title" style="text-align:center;">{{$t("txt_35")}}</td>
            </tr>
            <tr class="title">
                <td >{{$t("txt_30")}}</td>
                <td>{{$t("txt_31")}}</td>
                <td>{{$t("txt_32")}}</td>
                <td>{{$t("txt_33")}}</td>
                <td>{{$t("txt_34")}}</td>
            </tr>
            <tr>
                <td style="vertical-align:middle;">RRV</td>
                <td>
                    {{$t("txt_36")}}<br>
                    {{$t("txt_37")}}
                </td>
                <td>
                    25% 以上<br>
                    10% 以上
                </td>
                <td style="vertical-align:middle;"><span :class="data.rrvStatus ?'red':''">{{ data.rrv }}</span></td>
                <td style="vertical-align:middle;"><span :class="data.rrvStatus ?'red':''">{{ data.rrvTxt }}</span></td>
            </tr>
            <tr>
                <td style="vertical-align:middle;">
                    ST
                    <br>({{$t("txt_38")}}
                    <span>{{data.pulseCount}}</span>个)</td>
                <td>
                    {{$t("txt_39")}}
                    <br> {{$t("txt_40")}}
                    <br> {{$t("txt_41")}}
                    <br> {{$t("txt_42")}}
                </td>
                <td>
                    {{$t("txt_43")}}
                    <br> {{$t("txt_44")}}
                    <br> {{$t("txt_45")}}
                    <br> {{$t("txt_46")}}
                </td>
                <td colspan="2">
                    <span>{{$t("txt_47")}} {{data.stCount[0]}} 个</span>
                    <br>
                    <span :class="data.stCount[1] ? 'red' : ''">{{$t("txt_47")}} {{data.stCount[1]}} 个</span>
                    <br>
                    <span :class="data.stCount[2] ? 'red' : ''">{{$t("txt_47")}} {{data.stCount[2]}} 个</span>
                    <br>
                    <span :class="data.stCount[3] ? 'red' : ''">{{$t("txt_47")}} {{data.stCount[3]}} 个</span>
                </td>
            </tr>
             <tr>
                <td style="vertical-align:middle;">SYS</td>
                <td style="vertical-align:middle;">{{$t("txt_22")}}</td>
                <td>{{$t("txt_48")}}<br>{{$t("txt_22")}}(mmHg): 90 - 140</td>
                <td v-if="data.bph <= 140 && data.bph>= 90" style="vertical-align:middle;">{{data.bph}}</td>
                <td v-else-if="data.bph < 90" style="color:red;vertical-align:middle;">{{data.bph}}</td>
                <td v-else-if="data.bph > 140" style="color:red;vertical-align:middle;">{{data.bph}}</td>

                <td rowspan="2" :class="(data.bphStatus==1 || data.bplStatus==1) ? 'red_b' : ''" style="vertical-align:middle;">{{data.bpTxt2}}</td>
            </tr>
            <tr>
                <td style="vertical-align:middle;">DIAS</td>
                <td style="vertical-align:middle;">{{$t("txt_23")}}</td>
                <td>{{$t("txt_48")}}<br>{{$t("txt_23")}}(mmHg): 60 - 90</td>
                <td v-if="data.bpl<=90 && data.bpl>=60" style="vertical-align:middle;">{{data.bpl}}</td>
                <td v-else-if="data.bpl>90" style="color:red;vertical-align:middle;">{{data.bpl}}</td>
                <td v-else-if="data.bpl<60" style="color:red;vertical-align:middle;">{{data.bpl}}</td>
            </tr>
        </table>
    </div>
</template>

<script>
import LineChart from '@/components/chart/lineChart.vue';
export default {
    components: {
        LineChart
    },
    data() {
        return{
            client_account: '',
            report_id: '',
            data: {
                rrv: "",
                rrvTxt: "",
                bph: "",
                bpl: "",
                bphTxt: "",
                bplTxt: "",
                bpTxt2: "",
                bphStatus:0,
                bplStatus:0,
                pulseCount: "",
                pulse:'',
                stTxt: {},
                stCount:[0, 0, 0, 0],
            },
            lineChartData: {
                labels: [],
                datasets: []
            },
            isLoading: false,
        }
    },
    created(){
        const report = JSON.parse(sessionStorage.getItem('client_report'));
        this.client_account = report.account;
        this.report_id = report.id;
        this.getReport();
    },
    methods: {
        getReport() {
            this.isLoading = true
            const api = `${process.env.VUE_APP_APIPATH}/client/report/data`;
            const json = {
                client_account: this.client_account,
                report_id: this.report_id,
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    this.data = res.data.data;
                    this.drawPulse(res.data.data.pulse);
                }
                this.isLoading = false
            })
        },
        drawPulse(pulse) {
            let pulseAry = [];
            let labAry = [];
            pulseAry = pulse.split(" ");
            
            pulseAry.splice(0, 1);
            pulse = pulseAry.join(",");
            pulseAry.forEach((item, i) => {
                labAry.push(i);
            })
            
            let result = {
                labels: labAry,
                datasets: [
                {
                    label: `脈波數據(總脈波 ${this.data.pulseCount} 個)`,
                    backgroundColor: "transparent",
                    data: pulseAry,
                    borderColor: "rgba(29, 33, 36, .2)",
                    pointBackgroundColor: "rgba(171, 71, 188, 1)",
                    pointRadius: 1,
                }
                ]
            };
            this.lineChartData = result;
        },
    }
}
</script>